import React from 'react';
import { useDispatch } from 'react-redux';
import { ReactComponent as BurgerIcon } from '../../../../../resource/Burger.svg';
import { ReactComponent as LayoutIcon } from '../../../../../resource/Layout.svg';
import { ReactComponent as CameraIcon } from '../../../../../resource/CameraIcon.svg';
import { flatsViews } from '../../../constants/flatsViews';
import { setFlatsView } from '../../../store/actions/housingStockActions';
import ViewTabs from '../../common/ViewTabs/ViewTabs';

const viewTabsItems = [
  {
    key: flatsViews.table,
    renderIcon: ({ className }) => <BurgerIcon className={className} />,
  },
  {
    key: flatsViews.grid,
    renderIcon: ({ className }) => <LayoutIcon className={className} />,
  },
  {
    key: flatsViews.camera,
    renderIcon: ({ className }) => <CameraIcon className={className} />,
  },
];

const FlatsViewTabs = ({ className, flatsView }) => {
  const dispatch = useDispatch();

  const handleChange = (_evt, newValue) => {
    if (newValue !== flatsView) {
      dispatch(setFlatsView(newValue));
    }
  };

  return (
    <ViewTabs
      value={flatsView}
      onChange={handleChange}
      items={viewTabsItems}
      className={className}
    />
  );
};

export default FlatsViewTabs;
